import React from "react";
import { Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import "./PageTitle.scss";
import { AiOutlineCalendar } from "react-icons/ai";
import { MdMap } from "react-icons/md";

export default function PageTitle({
  image,
  mainTitle,
  longTitle,
  breadcrumbItems,
  mainDesc,
  strokeType,
  date,
  location,
}) {
  const items = [
    { title: <Link to="/">Pharma-SOS</Link> },
    ...breadcrumbItems.map((item) => ({
      title: <Link to={item.path}>{item.name}</Link>,
    })),
  ];

  return (
    <>
      <section
        className="breadcrum-placehlder position-relative before-content-primary"
        style={{ backgroundImage: `url(${image})` }}
      >
        {/* 
        {strokeType === "green" ? (
          <img
            src={AssetPath.shape.brushStrokeGreen}
            alt="Pharma-SOS | Commercial Operations Community"
            className="position-absolute bottom-0 start-0 w-100"
          />
        ) : (
          <img
            src={AssetPath.shape.brushStrokeWhite}
            alt="Pharma-SOS | Commercial Operations Community"
            className="position-absolute bottom-0 start-0 w-100"
          />
        )} 
        */}

        <div className="container">
          <div className="content" data-aos="fade-right">
            <div>
              <h1 className="text-white fw-bold">
                {mainTitle} <span className="text-green">{longTitle}</span>
              </h1>

              {mainDesc && <p className="text-white">{mainDesc}</p>}

              {date && (
                <p className="text-white mb-0">
                  <AiOutlineCalendar size={16} className="me-2" />
                  {date}
                </p>
              )}

              {location && (
                <p className="text-white">
                  <MdMap size={16} className="me-2" />
                  {location}
                </p>
              )}

              <div className="page-path">
                {items.length > 0 && <Breadcrumb items={items} />}{" "}
                {/* ✅ new API */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
